import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    prenom: '',
    numero: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.prenom || !formData.numero) {
      alert(t('whatsapp.form.validation.required'));
      return;
    }

    // Message formaté pour WhatsApp
    const message = t('whatsapp.form.message', { prenom: formData.prenom });
    
    // Encoder le message pour l'URL
    const encodedMessage = encodeURIComponent(message);
    
    // Numéro WhatsApp (format international sans +)
    const whatsappNumber = '221786057171';
    
    // URL WhatsApp
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    // Ouvrir WhatsApp
    window.open(whatsappUrl, '_blank');
    
    // Fermer la popup et réinitialiser le formulaire
    setIsPopupOpen(false);
    setFormData({ prenom: '', numero: '' });
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setFormData({ prenom: '', numero: '' });
  };

  return (
    <>
      {/* Bouton WhatsApp flottant */}
      <div 
        className="whatsapp-button"
        onClick={() => setIsPopupOpen(true)}
      >
        <img 
          src="/images/WhatsApp.svg.webp" 
          alt="WhatsApp" 
          className="whatsapp-icon"
        />
      </div>

      {/* Popup Modal */}
      {isPopupOpen && (
        <div className="whatsapp-popup-overlay" onClick={closePopup}>
          <div className="whatsapp-popup" onClick={(e) => e.stopPropagation()}>
            <div className="whatsapp-popup-header">
              <h3>{t('whatsapp.popup.title')}</h3>
              <button className="whatsapp-close-btn" onClick={closePopup}>
                ×
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="whatsapp-form">
              <div className="whatsapp-form-group">
                <label htmlFor="prenom">{t('whatsapp.form.fields.firstName')} *</label>
                <input
                  type="text"
                  id="prenom"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  placeholder={t('whatsapp.form.placeholders.firstName')}
                  required
                />
              </div>
              
              <div className="whatsapp-form-group">
                <label htmlFor="numero">{t('whatsapp.form.fields.phone')} *</label>
                <input
                  type="tel"
                  id="numero"
                  name="numero"
                  value={formData.numero}
                  onChange={handleInputChange}
                  placeholder={t('whatsapp.form.placeholders.phone')}
                  required
                />
              </div>
              
              <button type="submit" className="whatsapp-submit-btn">
                {t('whatsapp.form.submit')}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
